import { atom } from "jotai";

import { EventSignUpProcessSteps } from "@whoosh/features/src/Events/features/AddorEditSignUp";

export const eventSignUpModalStatusAtom = atom<{
  isOpen: boolean;
  overrideStep: EventSignUpProcessSteps | null;
}>({
  isOpen: false,
  overrideStep: null,
});
